export type UnknownError = {
    _tag: "UnknownError";
    message: string;
};

export const isUnknownError = (error: unknown): error is UnknownError => {
    return (
        typeof error === "object" &&
        error !== null &&
        "_tag" in error &&
        (error as { _tag?: string })._tag === "UnknownError"
    );
};

export type BookingNotAvailableError = {
    _tag: "BookingNotAvailableError";
    // "capacity": no free table or connected group fits the party — as opposed to a closed day or
    // a DB failure. Only set where the caller can act on it (the admin edit offers "save anyway").
    reason?: "capacity";
};

export const isBookingNotAvailableError = (error: unknown): error is BookingNotAvailableError => {
    return (
        typeof error === "object" &&
        error !== null &&
        "_tag" in error &&
        (error as { _tag?: string })._tag === "BookingNotAvailableError"
    );
};

export type DoubleBookingError = {
    _tag: "DoubleBookingError";
};

export type InvalidLayoutError = {
    _tag: "InvalidLayoutError";
    message: string;
};

export type InvalidFeedbackTokenError = {
    _tag: "InvalidFeedbackTokenError";
};

export type FeedbackAlreadySubmittedError = {
    _tag: "FeedbackAlreadySubmittedError";
};
